export default __webpack_public_path__ + "static/media/Path3439.2de576a9.svg";